import { type Moment } from "moment";
import "moment/locale/de";

export const renderTime = (m?: Moment, currentLang: string = "en"): string => {
  if (!m) return "";
  return m.clone().locale(currentLang).format("L LT");
};
